import {
  ARTIST_IMPORT_BY_CSV,
  SERVICE_PROVIDER_IMPORT_BY_CSV,
  USER_IMPORT_BY_CSV,
} from "../services/ApiCalls";
import URLS from "../services/URLS";
import { makingOptionsFromArr } from "./utilities";

export const statusEnum = {
  requested: { label: "Requested", value: "requested" },
  cancelled: { label: "Cancelled", value: "cancelled" },
  rejected: { label: "Rejected", value: "rejected" },
  pickUpSchedule: { label: "Pickup-Schedule", value: "pickUpScheduled" },
  orderPickedUp: { label: "Order Picked up", value: "orderPickedUp" },
  pending: { label: "Payment Pending", value: "pending" },
  confirmed: { label: "Payment Completed", value: "confirmed" },
  inProcess: { label: "Service in process", value: "inroute" },
  outForDelivery: { label: "Out For Delivery", value: "OutForDelivery" },
  completed: { label: "Order delivered", value: "completed" },
};

export const paginationLimitArr = [5, 10, 20, 50, 100, 200, 500, 1000];

export const orderStatusArr = ["pending", "completed", "cancelled"];

export const defaultDeleteModelState = {
  show: false,
  dumpId: "",
};

export const activeInactiveOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "InActive",
    value: "Inactive",
  },
  {
    label: "Blocked",
    value: "Blocked",
  },
];

export const roomStatusOptions = [
 { label: "All", value: "" },
    { label: "Available", value: "Available" },
    { label: "Unavailable", value: "Unavailable" },
    { label: "Occupied", value: "Occupied" },
    { label: "Maintenance", value: "Maintenance" }
];

export const pendingOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "pending",
    value: "pending",
  },
  {
    label: "completed",
    value: "completed",
  },
];
export const promotionListFilterOptions = [
  {
    label: "All",
    value: "",
  },
   {
    label: "Active",
    value: "active",
  },
  {
    label: "InActive",
    value: "inactive",
  },
  {
    label: "Deleted",
    value: "deleted",
  }
];
export const AppIntoListFilterOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "InActive",
    value: "inactive",
  },
  {
    label: "Archived",
    value: "archived",
  }
];
export const ReviewRequestFilterOptions=[
    {
    label: "All",
    value: "",
  },
  {
    label: "Pending",
    value: "Pending",
  },
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  }

]
export const openCloseOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Open",
    value: "Open",
  },
  {
    label: "Close",
    value: "closed",
  },
   {
    label: "In Progress",
    value: "In Progress",
  },
];

export const countryFilter = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Thailand",
    value: "Thailand",
  },
  {
    label: "Vietnam",
    value: "Vietnam",
  },
];
export const AdminStatusOptionSubscription = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "In Active",
    value: "inactive",
  },
];

export const BookingStatusOptions = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Upcoming",
    value: "upcoming",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
];

export const csvImportEnum = {
  importHotel: {
    title: "Hotel",
    sampleUrl:"/csv/samplehotel.csv",
    api: (data) => USER_IMPORT_BY_CSV(data),
  },
};

export const activeInActiveArr = ["Active", "Inactive"];
export const TrueFalseArr = ["True", "False"];
export const PercentArr = ["Percent", "Flat"];

export const accountType = [
  { label: "Individual Account", value: "single" },
  { label: "Business Account", value: "enterprise" },
];

export const discountTypeArr = ["percent", "amount"];

export const adminTypeArr = ["admin", "sub-admin"];
